import { theme } from '@Guidelines/Theme/theme';
import describeScope from '@UI/Pages/Administration/AiCosts/Helpers/describeScope';
import aiCostsFiltersSignal, {
	setAiCostsFilters,
} from '@UI/Pages/Administration/AiCosts/Filters/Signals/aiCostsFiltersSignal';
import type AiCostFilterOptionsView from '@UI/Store/AiCosts/Views/AiCostFilterOptionsView';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import { css } from '@emotion/react';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Button } from '@verclam/ui-kit';

const reminderStyle = css`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: 0.75rem;
	margin: 0;
	font-family: ${theme.fonts.mono};
	font-size: ${theme.fontSizes.small};
	color: ${theme.colors.inkMuted};
`;

type Props = { options: AiCostFilterOptionsView | null };

const ScopeReminder: React.FC<Props> = ({ options }) => {
	const filters = useSignalValue(aiCostsFiltersSignal);

	const handleClear = React.useCallback(() => {
		setAiCostsFilters(aiCostsFiltersSignal.peek().clearScope());
	}, []);

	return (
		<p css={reminderStyle}>
			<span>{`${describeScope(filters, options)} · heure de Paris`}</span>
			<ConditionalLoader data={filters.hasScope}>
				<Button type="button" label="Effacer les filtres" link onClick={handleClear} />
			</ConditionalLoader>
		</p>
	);
};

export default ScopeReminder;
